import React from "react";
import {
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Alert,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Backdrop } from "@mui/material";
import { Formik } from "formik";
import GeneralDialog from "src/components/GeneralDialog";
import UrlInput from "../../Input/urlInput/urlInput.container";
import RangeNumberInput from "../../Input/rangeNumberInput/rangeNumberInput.container";
import UnassignAvailabilityListTableContainer from "../../table/unassignAvailabilityListTable/unassignAvailabilityListTable.container";

const useStyles = makeStyles((theme) => ({
  accessBox: {
    display: "flex",
    flexFlow: "column",
  },
  scrollContainer: {
    maxHeight: "70vh",
    overflowY: "auto",
    backgroundColor: "#f3f3f3",
  },
  root: {
    backgroundColor: "#ffffff",
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  methodSelect: {
    minWidth: 250,
    backgroundColor: "#ffffff",
  },
  alertMessage: {
    marginTop: theme.spacing(2),
  },
  previewLabel: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: "#808080",
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff',
  },
}));

export default function UnassignPanelComponent({
  selectedCompany,
  selectedMethod,
  urlInput,
  validatedItems,
  isValidating,
  isUpdating,
  isUpdateButtonDisabled,
  showConfirmDialog,
  setUrlInput,
  handleMethodChange,
  handleFieldChange,
  handleValidateUrls,
  handleValidateRange,
  handleDeleteItem,
  handleSubmit,
  handleConfirmUnassign,
  handleCancelDialog,
  onSerialNumberAssignDialogCloseClick,
}) {
  const classes = useStyles();

  if (!selectedCompany) {
    return null;
  }
  return (
  <>
    <Formik>
      {(formik) => (
        <form onSubmit={formik.handleSubmit}>
          <DialogContent dividers className={classes.scrollContainer}>
            {/* Method Selector */}
            <Box className={classes.section}>
              <FormControl variant="outlined" className={classes.methodSelect}>
                <InputLabel>Type</InputLabel>
                <Select
                  value={selectedMethod}
                  onChange={handleMethodChange}
                  label="Type"
                  disabled={isValidating || isUpdating}
                >
                  <MenuItem value="serial_num">Serial Number</MenuItem>
                  <MenuItem value="seq_num">Sequence Number</MenuItem>
                  <MenuItem value="url">Qr Code</MenuItem>
                </Select>
              </FormControl>
              <Alert severity="warning" className={classes.alertMessage}>
                Once the Serial Number has been scanned or any stockflow
                action has been performed, it can no longer be unassigned.
              </Alert>
            </Box>
            {/* Input section based on method selected */}
            <Box>
              {selectedMethod === "url" ? (
                <UrlInput
                  urlInput={urlInput}
                  setUrlInput={setUrlInput}
                  onValidate={handleValidateUrls}
                  onFieldChange={handleFieldChange}
                  isValidating={isValidating}
                />
              ) : (
                <RangeNumberInput
                  key={selectedMethod}
                  onValidate={handleValidateRange}
                  onFieldChange={handleFieldChange}
                  isValidating={isValidating}
                  selectedMethod={selectedMethod}
                />
              )}
            </Box>
            {/* Preview Table */}
            <Box className={classes.section}>
              <Typography variant="body1" className={classes.previewLabel}>
                Preview
              </Typography>
              <UnassignAvailabilityListTableContainer
                validatedItems={validatedItems}
                onDeleteItem={handleDeleteItem}
                isUpdating={isUpdating}
                selectedMethod={selectedMethod}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="text"
              type="button"
              disabled={isUpdating}
              onClick={onSerialNumberAssignDialogCloseClick}
              style={{ color: "black" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              type="button"
              disabled={isUpdating || isUpdateButtonDisabled}
              onClick={handleSubmit}
            >
              Update
            </Button>
          </DialogActions>

          {/* Confirmation Dialog */}
          <GeneralDialog
            isOpen={showConfirmDialog}
            handleClose={handleCancelDialog}
            handleProceed={handleConfirmUnassign}
            title="Unassign Serial Number"
            description="Are you sure you want to unassign serial number?"
            type="danger"
          />
        </form>
      )}
    </Formik>
    <Backdrop open={isUpdating} className={classes.backdrop}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Box>
            <CircularProgress color="inherit" />
          </Box>
          <Box pt={1}>
            <Typography>Unassigning...</Typography>
          </Box>
        </Box>
    </Backdrop>
  </>
  );
}
